if ( typeof HoculusInvoiceFields !== 'function' ) {

  
  class HoculusInvoiceFields extends HTMLElement {
    constructor() {
      super();

      this.vatLabel = 'Codice fiscale / P. iva';
      this.sdiLabel = 'PEC / SDI';
      this.clientTypeLabel = 'Persona giuridica';

      this.invoiceCheckbox = document.getElementById('show-fields');
      this.vatField = this.querySelector('#vat-number');
      this.sdiField = this.querySelector('#sdi-number');
      this.clientTypeField = this.querySelector('#client-type');
      this.clientTypeToggle = this.querySelector('#client-type-toggle');

      this.invoiceCheckbox.addEventListener('change', this.onToggleFields);

      this.vatField.addEventListener('input', debounce(this.onInput, 300));
      this.sdiField.addEventListener('input', debounce(this.onInput, 300));
      this.clientTypeToggle.addEventListener('change', this.onClientTypeChange);

      this.setInitialValue();

      this.removeCartAttrs();
    }

    onToggleFields = event => {
      const isChecked = event.target.checked;

      this.setRequired(isChecked);

      localStorage.setItem(event.target.id, isChecked);

      if (isChecked) {
        this.setFieldsName();
        this.setFormAttr();
      } else {
        this.removeFieldsName();
        this.removeFormAttr();
        this.removeCartAttrs();
      }
    }

    onInput = event => {
      localStorage.setItem(event.target.id, event.target.value);

      const isSDIField = event.target === this.sdiField;
      if (isSDIField) {
        this.setSDIFieldType();
      }
    }

    onClientTypeChange = event => {
      const isChecked = event.target.checked;
      this.clientTypeField.value = isChecked ? 'Si' : 'No';
      localStorage.setItem(event.target.id, isChecked);
    }

    setRequired(isRequired) {
      this.vatField.required = isRequired;
      this.sdiField.required = isRequired;
    }

    setSDIFieldType() {
      const SDI_CODE_LENGTH = 7;
      if (this.sdiField.value.trim().length > SDI_CODE_LENGTH) this.sdiField.type = 'email';
      else this.sdiField.type = 'text';
    }
    
    setFieldsName() {
      this.vatField.setAttribute('name', `attributes[${this.vatLabel}]`);
      this.sdiField.setAttribute('name', `attributes[${this.sdiLabel}]`);
      this.clientTypeField.setAttribute('name', `attributes[${this.clientTypeLabel}]`);
    }

    removeFieldsName() {
      this.vatField.removeAttribute('name');
      this.sdiField.removeAttribute('name');
      this.clientTypeField.removeAttribute('name');
    }

    setFormAttr() {
      [this.vatField, this.sdiField, this.clientTypeField]
        .forEach(field => field.setAttribute('form', field.dataset.form));
    }

    removeFormAttr() {
      [this.vatField, this.sdiField, this.clientTypeField]
        .forEach(field => field.removeAttribute('form'));
    }

    setInitialValue() {
      const vatValue = localStorage.getItem(this.vatField.id);
      const sdiValue = localStorage.getItem(this.sdiField.id);
      const clientTypeToggleValue = localStorage.getItem(this.clientTypeToggle.id);
      const invoiceFieldsVisible = localStorage.getItem(this.invoiceCheckbox.id) === 'true';
      
      this.vatField.value = vatValue;
      this.sdiField.value = sdiValue;
      
      console.log('Toggle', localStorage.getItem(this.clientTypeToggle.id))

      this.invoiceCheckbox.checked = invoiceFieldsVisible;
      this.clientTypeToggle.checked = clientTypeToggleValue === 'true';
      this.clientTypeField.value = this.clientTypeToggle.checked ? 'Si' : 'No';

      this.setRequired(this.invoiceCheckbox.checked);
      this.setSDIFieldType();

      if (this.invoiceCheckbox.checked) {
        this.setFieldsName();
        this.setFormAttr();
      }
    }

    removeCartAttrs() {

      try {

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              [this.vatLabel]: '',
              [this.sdiLabel]: '',
              [this.clientTypeLabel]: ''
            }
          })
        });

      } catch (err) {
        console.log(err);
      }
    }
  }

  customElements.define('hoculus-invoice-fields', HoculusInvoiceFields);

}